import { render, staticRenderFns } from "./TodoSalesOrderConsignment.vue?vue&type=template&id=565b4136&scoped=true&"
import script from "./TodoSalesOrderConsignment.vue?vue&type=script&lang=js&"
export * from "./TodoSalesOrderConsignment.vue?vue&type=script&lang=js&"
import style0 from "./TodoSalesOrderConsignment.vue?vue&type=style&index=0&id=565b4136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b4136",
  null
  
)

export default component.exports